import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import { coreExtensionData } from '@backstage/frontend-plugin-api';
import { PageWithHeader } from '@backstage/core-components';

/**
 * The plugin renders its content without a banner and expects the plugin header
 * toolbar; replace that toolbar with the themed banner used before 0.6.
 */
const notificationsFeature = notificationsPlugin.withOverrides({
  extensions: [
    notificationsPlugin.getExtension('page:notifications').override({
      *factory(originalFactory) {
        const outputs = originalFactory({
          params: {
            path: '/notifications',
            noHeader: true,
          },
        });
        for (const output of outputs) {
          if (output.id === coreExtensionData.reactElement.id) {
            yield coreExtensionData.reactElement(
              <PageWithHeader title="Notifications" themeId="tool">
                {output.value as JSX.Element}
              </PageWithHeader>,
            );
          } else {
            yield output;
          }
        }
      },
    }),
  ],
});

export default notificationsFeature;
